var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.58333C10.4487 4.58333 10.8125 4.94711 10.8125 5.39583V9.1875H14.6042C15.0529 9.1875 15.4167 9.55128 15.4167 10C15.4167 10.4487 15.0529 10.8125 14.6042 10.8125H10.8125V14.6042C10.8125 15.0529 10.4487 15.4167 10 15.4167C9.55128 15.4167 9.1875 15.0529 9.1875 14.6042V10.8125H5.39583C4.94711 10.8125 4.58333 10.4487 4.58333 10C4.58333 9.55128 4.94711 9.1875 5.39583 9.1875H9.1875V5.39583C9.1875 4.94711 9.55128 4.58333 10 4.58333ZM0.25 3.77083C0.25 1.82633 1.82633 0.25 3.77083 0.25H16.2292C18.1736 0.25 19.75 1.82633 19.75 3.77083V16.2292C19.75 18.1736 18.1736 19.75 16.2292 19.75H3.77083C1.82633 19.75 0.25 18.1736 0.25 16.2292V3.77083ZM3.77083 1.875C2.72379 1.875 1.875 2.72379 1.875 3.77083V16.2292C1.875 17.2762 2.72379 18.125 3.77083 18.125H16.2292C17.2762 18.125 18.125 17.2762 18.125 16.2292V3.77083C18.125 2.72379 17.2762 1.875 16.2292 1.875H3.77083Z",
    fill: "#D0C9D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f04af4a3f6cbe00b82990010fb6faabc.svg";
export { ForwardRef as ReactComponent };